var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconNotice01 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#icon_notice_01_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M10 2.262c4.264 0 7.738 3.474 7.738 7.738S14.264 17.738 10 17.738 2.262 14.264 2.262 10 5.736 2.262 10 2.262m0-1.548A9.283 9.283 0 0 0 .714 10 9.283 9.283 0 0 0 10 19.286 9.283 9.283 0 0 0 19.286 10 9.283 9.283 0 0 0 10 .714m.774 13.929H9.226v-6.19h1.548zM10 5.163A.968.968 0 1 1 10 7.1a.968.968 0 0 1 0-1.935"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "icon_notice_01_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h20v20H0z"
})))));
export default SvgIconNotice01;